<template>
    <div v-if="currentAccountSets" class="flex items-center">
        <div class="flex items-center " style="height: 32px;">
            <img :src="require('@/assets/qy3.png')" style="width: 20px;height: 20px;margin-bottom: 7px;">
            <span style="line-height: 32px;padding-bottom: 4px;font-size: 18px;">企业名称：</span>
        </div>
        <Select ref="astRef"
                v-model="currentAccountSetsId"
                :datas="myAccountSets"
                :deletable="false"
                :equalWidth="false"
                className="as-select accountList"
                filterable
                keyName="id"
                :style="accountSetsSelectStyle"
                titleName="companyName" @change="changeAccountSets">
            <template #item="{item}">
                {{ item.companyName }}
                <vxe-button mode="text" icon="vxe-icon-copy" class="mr-20px" @click.stop="copyEvent(item.companyName)" style="padding: 0;"></vxe-button>
            </template>
        </Select>
        <vxe-button mode="text" icon="vxe-icon-copy" @click="copyEvent(null)" style="padding: 0;"></vxe-button>
    </div>
</template>
<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import {dictMapping, loading, message} from "heyui.ext";
import common from "@api/common";
import {VxeUI} from "vxe-pc-ui";

export default {
    name: 'AppHeaderAccountSets',
    data() {
        return {
            messageList: [],
            currentAccountSetsId: null,
            currentAccountSetsName:null,
        };
    },
    methods: {
        dictMapping,
        ...mapMutations(['newTab']),
        changeAccountSets(as) {
            if (as.id !== this.currentAccountSets.id) {
                loading("正在切换，请稍后...");
                common.changeAccountSets(as.id).then(() => {
                    message('切换成功！');
                    localStorage.removeItem(this.currentTabKey);
                    localStorage.removeItem(this.currentTabAllKey);
                    if(this.prod){
                        window.location.replace('https://financial.hxkjzg.com?isManage=2&accountSetId=' + as.id);
                    }else{
                        window.location.replace('http://localhost:9012?isManage=2&accountSetId=' + as.id);
                    }
                });
            }
        },
        copyEvent(name){
            if(name){
                VxeUI.clipboard.copy(name)
                this.$refs.astRef.dropdown.hide();
            }else{
                VxeUI.clipboard.copy(this.currentAccountSetsName)
            }
            VxeUI.modal.message({
                status: 'success',
                content: '复制成功',
                duration: 1000
            })
        },
        editAs() {
            this.newTab({
                key: 'Account',
                title: "账套"
            })
        }
    },
    computed: {
        ...mapState(['currentAccountSets', 'myAccountSets', 'prod']),
        ...mapGetters(['currentTabKey','currentTabAllKey']),
        selectedAccountSetsName() {
            const accountSets = this.myAccountSets.find(item => item.id === this.currentAccountSetsId);
            return accountSets?.companyName || this.currentAccountSets?.companyName || '';
        },
        accountSetsSelectStyle() {
            const textWidth = [...this.selectedAccountSetsName].reduce((width, char) => {
                return width + (char.charCodeAt(0) > 255 ? 18 : 9);
            }, 0);
            const width = Math.min(Math.max(textWidth + 48, 120), 420);

            return {
                width: `${width}px`
            };
        },
    },
    watch: {
        'currentAccountSets.id'(id) {
            this.currentAccountSetsId = id;
            this.currentAccountSetsName = this.currentAccountSets.companyName;
        }
    },
    created() {
        if (this.currentAccountSets) {
            this.currentAccountSetsId = this.currentAccountSets.id;
            this.currentAccountSetsName = this.currentAccountSets.companyName;
        }
    }
};
</script>
<style lang='less'>
.app-header-message-vue {
    float: left;
    margin-right: 10px;

    .h-dropdowncustom-show {
        height: @layout-header-height;

        .app-header-icon-item {
            margin-right: 0;
        }

        &.h-pop-trigger {
            background: @hover-background-color;
        }
    }
}

.app-account-sets-dropdown-dropdown-container {
    width: 300px;
    min-height: 300px;

    .common-list-container {
        .common-list-item {
            cursor: pointer;
            padding: 10px;

            &:hover {
                background: @hover-background-color;
            }

            &.current {
                background: @primary-color;
                color: @white-color;
            }
        }
    }
}

.accountList,
.accountList *,
.accountList .h-input,
.accountList .h-select,
.accountList .h-input-inner,
.accountList .h-select-inner,
.accountList .h-input-wrapper,
.accountList .h-select-wrapper {
    border: none !important;
    //border-bottom: 1px solid #dcdfe6 !important;
    outline: none !important;
    box-shadow: none !important;
    color: black;
}

/* 针对所有可能的边框相关属性 */
[class*="accountList"] {
    border: none !important;
    //border-bottom: 1px solid #dcdfe6 !important;
    outline: none !important;
    box-shadow: none !important;
    color: black;

    &::before,
    &::after {
        border: none !important;
        //border-bottom: 1px solid #dcdfe6 !important;
        outline: none !important;
        box-shadow: none !important;
    }
}

/* 强制覆盖所有输入框和选择框的边框 */
.accountList input,
.accountList select,
.accountList textarea {
    border: none !important;
    //border-bottom: 1px solid #dcdfe6 !important;
    outline: none !important;
    box-shadow: none !important;
    color: black;
}
.h-select-show.as-select.accountList-show {
    //background-color: #F3F4F5 !important;
    font-size: 18px;
}
</style>
